import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { createGameModalStyle } from '../../../../css/ModalCss/ModalCss';
import { CrossIcon } from '../../svg/Icons';
import PropTypes from 'prop-types';
import { toastAction } from '../../../../redux/action/toastAction';
import { useDispatch } from 'react-redux';
import {
  planGetAction,
  planUpdateAction,
  planCreateAction,
} from '../../../../redux/action/plan';
import JsonEditor from '../../Editor/JsonEditor';

const CreatePlanModal = ({
  isModalOpen,
  onToggleModal,
  planId,
  actionType = 'CREATE',
}) => {
  const dispatch = useDispatch();
  const [plan, setPlan] = useState(undefined);
  const [editorJson, setEditorJson] = useState(undefined);
  const [error, setError] = useState(undefined);

  const onUpdatePlan = () => {
    dispatch(planUpdateAction(planId, plan, onToggleModal));
  };
  const onCreatePlan = value => {
    dispatch(planCreateAction(value, onToggleModal));
  };
  const onCallBack = data => {
    let temp = { ...data };
    delete temp['_id'];
    delete temp['root_plan'];
    setPlan(temp);
    var str = JSON.stringify(temp, undefined, 4);
    setEditorJson(str);
    document.getElementById('plan_json_editor').innerHTML = str;
  };
  const onGetPlan = () => {
    dispatch(planGetAction(planId, onCallBack));
  };
  const onChangeCreateGame = inputData => {
    let data;
    setEditorJson(inputData);
    try {
      data = JSON.parse(inputData);
      setError(undefined);
    } catch (err) {
      const errMsg = JSON.stringify(err?.message || err);
      setError(errMsg);
    }
    setPlan(data);
  };
  const onSubmit = () => {
    if (error) {
      toastAction.error('Please resolve the error');
      return;
    }
    if (actionType === 'UPDATE' && planId) {
      onUpdatePlan();
      return;
    }
    onCreatePlan(plan);
  };

  useEffect(() => {
    if (planId && actionType === 'UPDATE') {
      onGetPlan();
    }
  }, [planId]);
  return (
    <ReactModal
      isOpen={isModalOpen}
      ariaHideApp={false}
      overlayClassName="f-modal-overlay"
      shouldCloseOnOverlayClick={true}
      style={createGameModalStyle}
      className=""
    >
      <div className="relative w-full h-full text-black">
        <div className="flex w-full justify-between">
          <div className="h5-thin">
            {' '}
            {actionType === 'CREATE' ? 'Create' : 'Update'} Plan
          </div>
          <div className="flex justify-end cursor-pointer p-2 ">
            <div onClick={() => onToggleModal()}>
              <CrossIcon />
            </div>
          </div>
        </div>
        <div className="mt-4">
          {error && <p className="caption text-red-400">{error}</p>}
          <p className="rounded-lg">
            <JsonEditor code={editorJson} onChange={onChangeCreateGame} />
          </p>
        </div>
        <div className="w-full flex justify-end mt-4">
          <div
            onClick={() => onToggleModal()}
            className="cursor-pointer p-2 px-4 border-[1px] border-black body-2 bg-slate-200 rounded-lg mx-2"
          >
            close
          </div>
          <div
            className="cursor-pointer p-2 px-4 bg-green-800 rounded-lg body-2 text-white"
            onClick={onSubmit}
          >
            {actionType === 'CREATE' ? 'create' : 'update'}
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

CreatePlanModal.propTypes = {
  isModalOpen: PropTypes.bool,
  onToggleModal: PropTypes.func,
  planId: PropTypes.string,
  actionType: PropTypes.string,
};
export default CreatePlanModal;
